import { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router";

const user = {
    fullName: "Бек Талгат",
    role: "Администратор",
};

const navGroups = [
    {
        title: "Продажи",
        items: [
            { label: "Заказы", path: "/orders", icon: "🧾" },
            { label: "Клиенты", path: "/clients", icon: "👥" },
        ],
    },
    {
        title: "Каталог",
        items: [
            { label: "Товары", path: "/products", icon: "📦" },
            { label: "Категории товаров", path: "/product-categories", icon: "🗂" },
        ],
    },
    {
        title: "Контент",
        items: [
            { label: "Решения", path: "/solutions", icon: "💡" },
        ],
    },
];

export const Header = () => {
    const [isOpen, setIsOpen] = useState(false);
    const location = useLocation();

    const initials = user.fullName
        .split(" ")
        .map((word) => word[0])
        .join("")
        .slice(0, 2);

    useEffect(() => {
        setIsOpen(false);
    }, [location.pathname]);

    useEffect(() => {
        document.body.style.overflow = isOpen ? "hidden" : "";

        return () => {
            document.body.style.overflow = "";
        };
    }, [isOpen]);

    return (
        <>
            <header className="admin-mobile-header">
                <div className="admin-mobile-brand">
                    <div className="admin-logo">L</div>

                    <div>
                        <strong>Luminopt</strong>
                        <span>Панель управления</span>
                    </div>
                </div>

                <button
                    className="admin-burger"
                    type="button"
                    onClick={() => setIsOpen(true)}
                >
                    ☰
                </button>
            </header>

            {isOpen && (
                <button
                    className="admin-overlay"
                    type="button"
                    onClick={() => setIsOpen(false)}
                />
            )}

            <aside className={isOpen ? "admin-sidebar admin-sidebar--open" : "admin-sidebar"}>
                <div className="admin-sidebar-top">
                    <div className="admin-logo">L</div>

                    <div className="admin-brand">
                        <h1>Luminopt</h1>
                        <p>Панель управления</p>
                    </div>

                    <button
                        className="admin-close"
                        type="button"
                        onClick={() => setIsOpen(false)}
                    >
                        ✕
                    </button>
                </div>

                <div className="admin-user">
                    <div className="admin-user-avatar">{initials}</div>

                    <div className="admin-user-info">
                        <strong>{user.fullName}</strong>
                        <span>{user.role}</span>
                    </div>
                </div>

                <nav className="admin-nav">
                    {navGroups.map((group) => (
                        <div className="admin-nav-group" key={group.title}>
                            <p>{group.title}</p>

                            <div className="admin-nav-links">
                                {group.items.map((item) => (
                                    <NavLink
                                        key={item.path}
                                        to={item.path}
                                        className={({ isActive }) =>
                                            isActive ? "admin-nav-link active" : "admin-nav-link"
                                        }
                                    >
                                        <span>{item.icon}</span>
                                        {item.label}
                                    </NavLink>
                                ))}
                            </div>
                        </div>
                    ))}
                </nav>

                <button onClick={() => {
                    localStorage.clear();
                    window.location.reload();
                }} className="admin-logout" type="button">
                    ↩ Выйти
                </button>
            </aside>
        </>
    );
};
